<template>
    <div @keyup.enter="handleSubmit('formLogin')" class="layout" id="Login">
        <div class="container">
            <q-dialog persistent position="right" v-model="dialog">
                <AddApplication @closeCreatePartnerDialog="dialog=false"></AddApplication>
            </q-dialog>

            <q-dialog persistent position="right" v-model="forgotPasswordDialog">
                <Forgot @closeForgotPasswordDialog="forgotPasswordDialog=false"></Forgot>
            </q-dialog>
            <!--<div @click="dialog=true" class="addButton-2 mr-0 d-flex" style="height: 40px;">-->
            <!--<div class=" mx-auto my-auto">Add Application</div>-->
            <!--</div>-->
            <div class="row">
                <div class="col-12 col-sm-12 col-md-12">
                    <div class="login-right-content login-bg">
                        <!--                        <div >-->
                        <!--                            <img style="width: 50%" class="pt-5 d-block mx-auto" src="../../../src/assets/login_image.png" alt="">-->
                        <!--                        </div>-->

                        <div class="loginBox p-0 pt-4 ">
                            <q-form ref="formLogin">
                                <div>
                                    <div class="login-logo mx-auto">
                                        <img class="mx-auto" src="../../assets/logo.png"/>
                                    </div>
                                    <!--<h1>LOGIN</h1>-->
                                    <h3 class="text-center text-white">Partner Login</h3>
                                </div>
                                <q-input :rules="[ val => val && val.length > 0]" class="searchBox my-3 p-2"
                                         dense label="Username"
                                         lazy-rules outlined style="background: #fff"
                                         v-model="formLogin.username">
                                    <template slot="prepend">
                                        <!--<q-icon name="person"/>-->
                                    </template>
                                </q-input>

                                <q-input :rules="[ val => val && val.length > 0]" class="searchBox my-3 p-2"
                                         dense label="Password"
                                         lazy-rules outlined style="background: #fff"
                                         type="password"
                                         v-model="formLogin.password">
                                    <template slot="prepend">
                                        <!--<q-icon name="lock"/>-->
                                    </template>
                                </q-input>

                                <q-btn @click="handleSubmit('formLogin')" class="pd-btn w-100" unelevated
                                       style="height: 50px; font-size: 24px; background: #023399 !important; letter-spacing: 5px;">LOGIN
                                </q-btn>
                                <p class="text-center my-3">OR</p>
                                <div class="login-join-button w-100 ">
                                    <q-btn unelevated @click="dialog=true" class="pd-btn w-100"
                                           style="height: 50px; font-size: 24px; background: #0da99b !important; letter-spacing: 2px;">
                                        Become Amity Partner
                                    </q-btn>
                                </div>
                                <div class="text-center mt-4">
                                    <a @click="forgotPasswordDialog=true" class="text-white" href="javascript:undefined">FORGOT
                                        PASSWORD?</a>
                                </div>
                            </q-form>
                        </div>
                    </div>
                </div>
                <div v-if="!responsive" class="col-12">
                    <footer class="px-5" style="border-top: 1px solid lightgrey">
                        <div class="row" style="align-items: center; ">
                            <div class="col-3">
                                <p class="mb-0 mt-1" style="color: grey; font-size: 12px;">Powered by</p>
                                <div class="footer-logo mb-2">
                                    <a href="http://www.amitygroup.in/" target="_blank">
                                        <img alt="" class="w-100 d-block mx-auto" src="../../assets/footer-logo.png">
                                    </a>
                                </div>
                            </div>
                            <div class="col-6">
                                <p class="text-center mb-1" style="color: grey">For More Detail Contact Us on : 0261
                                    6657000 I <a href="" style="color: grey">support@amitybiz.net</a></p>
                                <p class="text-center mb-1" style="color: #959595; font-size: 12px;">Copyright &copy;
                                    2019 Amity Infosoft (P) Ltd., All rights reserved</p>
                            </div>
                            <div class="col-3">
                                <div class="d-flex" style="justify-content: flex-end;">
                                    <div class="social-icons mx-2">
                                        <a href="https://www.facebook.com/amityinfosoft" target="_blank"><i
                                                class="fab fa-facebook-f"></i></a>
                                    </div>
                                    <div class="social-icons mx-2">
                                        <a href="https://www.linkedin.com/company/amityinfosoft" target="_blank"><i
                                                class="fab fa-linkedin-in"></i></a>
                                    </div>
                                    <div class="social-icons mx-2">
                                        <a href="https://twitter.com/Amityinfosoft" target="_blank"><i
                                                class="fab fa-twitter"></i></a>
                                    </div>
                                    <div class="social-icons ml-2">
                                        <a href="https://www.instagram.com/amityinfosoft/" target="_blank"><i
                                                class="fab fa-instagram"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </footer>
                </div>
            </div>

        </div>

        </div>
        <!--<div class="ppf-bg_img">-->
        <!--<div class="card">-->
        <!--<q-form ref="formLogin">-->
        <!--<div class="row">-->
        <!--<div class="col-12">-->
        <!--<div class="card-title">-->
        <!--<img src="../../assets/logo-old.png" width="40%"/>-->
        <!--<h5 style="letter-spacing: 5px">PARTNER</h5>-->
        <!--</div>-->
        <!--</div>-->
        <!--<div class="col-12">-->
        <!--<q-input :rules="[ val => val && val.length > 0]" dense-->
        <!--label="Username" lazy-rules outlined-->
        <!--v-model="formLogin.username">-->
        <!--<template slot="prepend">-->
        <!--<q-icon name="person"/>-->
        <!--</template>-->
        <!--</q-input>-->
        <!--</div>-->
        <!--<div class="col-12">-->
        <!--<q-input :rules="[ val => val && val.length > 0]" dense-->
        <!--label="Password" lazy-rules outlined-->
        <!--type="password"-->
        <!--v-model="formLogin.password">-->
        <!--<template slot="prepend">-->
        <!--<q-icon name="lock"/>-->
        <!--</template>-->
        <!--</q-input>-->
        <!--</div>-->
        <!--<div class="col-8">-->
        <!--<q-checkbox label="Remember Me" v-model="rememberMe"></q-checkbox>-->
        <!--</div>-->
        <!--<div class="col-12">-->
        <!--<q-btn @click="handleSubmit('formLogin')" color="primary">LOGIN</q-btn>-->
        <!--</div>-->
        <!--</div>-->
        <!--</q-form>-->
        <!--</div>-->
        <!--</div>-->

    </div>

</template>

<script>
  import Constants from '../../Constants/Constant'
  import { NetworkCommunicator } from '../../plugins/NetworkResourceHandler'
  import AddApplication from '../AddApplication'
  import Forgot from '../User/Forgot'
  import {wsLink} from "@/vue-apollo";

  export default {
    name: 'Login',
    components: { AddApplication, Forgot },
    data () {
      return {
        formLogin: {
          username: '',
          password: '',
        },
        rememberMe: false,
        company: null,
        dialog: false,
        forgotPasswordDialog: false,
          responsive : false

      }
    },
    methods: {
        onResponsiveInverted() {
            if (window.innerWidth < 991) {
                this.responsive = true
            } else {
                this.responsive = false
            }
        },
      handleSubmit (name) {
        this.$refs[name].validate().then(success => {
          if (success) {
            this.doLogin()
          } else {
            this.$q.notify('Invalid Credential')
          }
        })
      },
      async doLogin () {
        let self = this
        let response = await NetworkCommunicator('POST', `${Constants.api_url}partnerOwnerLogin`,
          false, { mobile: this.formLogin.username, password: this.formLogin.password, deviceType: 'Web' }, {})
        if (response.flag) {
          localStorage.setItem('token', response.data.token)
          localStorage.setItem('user', JSON.stringify(response.data))
          const redirectUrl = localStorage.getItem('redirectAfterLogin');
          if(response.data.organization.isAggrementAccepted) {
           /*TODO: Close socket connection & reconnect will ensure a new connection with new token */
            wsLink.subscriptionClient.close();
            setTimeout(function () {
              if (response.data?.organization?.onlineOfflineType === 1) {
                if(redirectUrl) {
                    // window.location.href = redirectUrl;
                    self.$router.replace({ path: redirectUrl })
                    localStorage.removeItem('redirectAfterLogin');
                } else {
                    self.$router.replace({ path: '/Partners/Stock/Products' })
                }
              } else {
                self.$router.replace({ path: '/Partners/Dashboard' })
              }
            //   self.$router.go()
            }, 500)
          } else {
            setTimeout(function () {
              self.$router.replace({ path: '/Partners/Agreement' })
            //   self.$router.go()
            }, 100)
          }
        } else {
          this.$q.notify(response.message)
        }
      },
    },
      mounted() {
          this.onResponsiveInverted()
          window.addEventListener('resize', this.onResponsiveInverted)
      },
      beforeDestroy() {
          window.removeEventListener('resize', this.onResponsiveInverted)
      },

    beforeCreate () {
      if (localStorage.getItem('user') != undefined && localStorage.getItem('user') != '') {
        this.$router.replace({ path: '/' })
      }
    },
  }
</script>

<style scoped>
    .login-bg{
        background-image: url("../../assets/images/login-bg.jpg");
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;

    }

    .ppf-bg_img {
        background-image: url("../../assets/login-bg.jpg");
        display: flex;
        height: 100vh;
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
    }

    .ppf-bg_img .card {
        text-align: center;
        width: 350px;
        padding: 30px 40px;
        margin: auto;
        background-image: url("https://i.imgur.com/UbfG4Vh.png");
        background-color: #fff;
        background-repeat: no-repeat;
        background-position: bottom;
        border-radius: 4px;
        box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.3);
        position: relative;
        left: -24%;
    }

    .ppf-bg_img .card-title {
        padding: 15px 0;
    }

    .ppf-bg_img .ppf-bg_img .img {
        padding: 15px 0px;
    }

    .ppf-bg_img .btn-login {
        background-color: #e30c3e;
        color: #fff;
        font-size: 18px;
        transition: 0.5s;
        otline: none;
    }

    .ppf-bg_img .btn-login:hover {
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
    }

    .ppf-bg_img .ppf-checkbox {
        text-align: left;
        margin-bottom: 0;
        padding-bottom: 30px;
    }

    .login-cover{
        background-image: url("../../assets/Amity_Login.jpg");
        height: 400px;
        background-position: center;
        background-size: cover;
    }
</style>
